import { LINK_DISPLAY_NAME } from './linkConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';
import { ElementType } from '../elements/elementTypes';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: ElementType.LINK_TYPE,
        content: {
            url: null,
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: ElementType.LINK_TYPE,
        objectConstructorFn,
        displayName: LINK_DISPLAY_NAME,
        ...params,
    });
